// @ts-nocheck

import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { send } from '../../../../actions/network';
import useMergeProps from '../../../../hooks/useMergeProps';
import useModalContext from '../../../../hooks/useModalContext';
import { BoomStepContext } from '../../contexts/BoomStepContext';
import useOpenBoomView from '../../hooks/useOpenBoomView';
import { selectBoomUserProgressEntityStatus } from '../../selectors/user/userPrimary.selector';

import BoomStepView from './BoomStepView';
import makeBoomStepViewBetslipRefSelector from './BoomStepView.selector';

type PropsType = {
  className?: string;
};

const BoomStepViewContainer = (ownProps: PropsType) => {
  const dispatch = useDispatch();
  const { setOnBackButtonClick } = useModalContext();
  const { stepId } = useParams();
  const selector = makeBoomStepViewBetslipRefSelector();
  const selectorProps = useMemo(() => ({ stepId }), [stepId]);
  const stepStatus = useSelector((state) => selectBoomUserProgressEntityStatus(state, selectorProps));
  const selectedProps = useSelector((state) => selector(state, selectorProps));
  const openBoomView = useOpenBoomView();
  const { betslipReference: betslipRef } = selectedProps;

  const getBetslip = useCallback(
    (betslipReference) => dispatch(send({ getOneBetslip: { betslipReference } })),
    [dispatch],
  );

  useEffect(() => {
    if (betslipRef) {
      getBetslip(betslipRef);
    }
  }, [betslipRef, getBetslip]);

  const boomStepContextValue = useMemo(
    () => ({
      stepId,
      stepStatus,
    }),
    [stepId, stepStatus],
  );

  const onBackButtonClick = useCallback(
    () => () => {
      openBoomView();
    },
    [openBoomView],
  );

  useEffect(() => {
    if (setOnBackButtonClick) {
      setOnBackButtonClick(onBackButtonClick);

      return () => {
        setOnBackButtonClick(null);
      };
    }
  }, [setOnBackButtonClick, onBackButtonClick]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return (
    <BoomStepContext.Provider value={boomStepContextValue}>
      <BoomStepView {...enhancedProps} />
    </BoomStepContext.Provider>
  );
};

export default BoomStepViewContainer;
